wbApp.controller('DataExportHistoryCtrl', ['$scope', '$translate', '$filter', 'dataExportHistorySvc',
function ($scope, $translate, $filter, dataExportHistorySvc) {

    $scope.gridSettings = {
        grouping: {
            autoExpandAll: false
        },
        columns: [
            { dataField: 'month', caption: $translate.instant('TXT_LBL_MONTH'), dataType: 'string', groupIndex: 1},
            {
                dataField: 'createdAt', caption: $translate.instant('TXT_LBL_CREATED_AT'),
                dataType: 'date', format: 'shortDateShortTime',
                sortOrder: 'desc',
                width: '130px'
            },
            { dataField: 'dataExportType', caption: $translate.instant('TXT_LBL_EXPORT_TYPE'), dataType: 'string', width: '130px' },
            { dataField: 'exportedObjectType', caption: $translate.instant('TXT_LBL_OBJECT_TYPE'), dataType: 'string', width: '90px' },
            { dataField: 'exportedObjectID', caption: $translate.instant('TXT_LBL_OBJECT_ID'), dataType: 'number', width: '80px' },
            { dataField: 'errorCodeStr', caption: $translate.instant('TXT_LBL_CODE'), dataType: 'string', width: '80px' },
            { dataField: 'errorText', caption: $translate.instant('TXT_LBL_TEXT'), dataType: 'string' },
        ],
        summary: {
            groupItems: [{
                column: "dataExportHistoryID",
                summaryType: "count",
                displayFormat: "{0}",
                alignByColumn: false
            }, {
                column: "createdAt",
                summaryType: "min",
                displayFormat: " ",
                alignByColumn: true,
                showInColumn: 'errorText'
            }],
        },
        sortByGroupSummaryInfo: [
            {
                summaryItem: 1,
                sortOrder: 'desc'
            }
        ]
    }

    $scope.$on('refreshData', function (e, data) {
        $scope.dataExportHistory = dataExportHistorySvc.getAll(true);
    });

    $scope.dataExportHistory = dataExportHistorySvc.getAll();
}]);
